import React from 'react';

const TaskIcon = () => {
  return (
    <svg
      width='36'
      height='37'
      viewBox='0 0 36 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M30.0835 0.985596H5.91654C2.64893 0.985596 0 3.63452 0 6.90214V31.0691C0 34.3367 2.64893 36.9856 5.91654 36.9856H30.0835C33.3511 36.9856 36 34.3367 36 31.0691V6.90214C36 3.63452 33.3511 0.985596 30.0835 0.985596Z'
        fill='#FEDFCD'
      />
      <g filter='url(#filter0_di_1532_2224)'>
        <path
          d='M24.8743 8.18573H11.1237C10.505 8.19853 9.91671 8.45605 9.48763 8.90187C9.05855 9.34768 8.82372 9.94542 8.83459 10.5641V27.4155C8.82921 27.7214 8.88416 28.0255 8.9963 28.3102C9.10843 28.5949 9.27556 28.8547 9.48812 29.0748C9.70069 29.2949 9.95454 29.471 10.2352 29.593C10.5158 29.7149 10.8177 29.7805 11.1237 29.7857H24.8743C25.1802 29.7805 25.4821 29.7149 25.7628 29.593C26.0434 29.471 26.2972 29.2949 26.5098 29.0748C26.7224 28.8547 26.8895 28.5949 27.0016 28.3102C27.1138 28.0255 27.1687 27.7214 27.1633 27.4155V10.5641C27.1742 9.94542 26.9394 9.34768 26.5103 8.90187C26.0812 8.45605 25.4929 8.19853 24.8743 8.18573ZM11.6269 12.2931C11.6624 12.257 11.7048 12.2283 11.7514 12.2088C11.7981 12.1892 11.8482 12.1791 11.8989 12.1791C11.9495 12.1791 11.9996 12.1892 12.0463 12.2088C12.093 12.2283 12.1353 12.257 12.1708 12.2931L12.4143 12.5366L13.226 11.7249C13.2989 11.6786 13.3847 11.6569 13.4708 11.6627C13.5569 11.6685 13.6389 11.7017 13.7049 11.7573C13.7758 11.8301 13.8155 11.9277 13.8155 12.0292C13.8155 12.1308 13.7758 12.2284 13.7049 12.3012L12.6822 13.3483C12.6487 13.3858 12.6073 13.4155 12.561 13.4351C12.5147 13.4548 12.4646 13.4639 12.4143 13.4619C12.3641 13.4634 12.3142 13.454 12.268 13.4344C12.2217 13.4148 12.1803 13.3854 12.1464 13.3483L11.6269 12.8369C11.5596 12.7623 11.5224 12.6654 11.5224 12.565C11.5224 12.4645 11.5596 12.3676 11.6269 12.2931ZM12.6335 22.4477C12.391 22.4477 12.1541 22.3759 11.9525 22.2412C11.7509 22.1065 11.5938 21.9151 11.5011 21.6911C11.4083 21.4671 11.384 21.2207 11.4313 20.9829C11.4786 20.7451 11.5953 20.5267 11.7668 20.3553C11.9382 20.1839 12.1566 20.0672 12.3943 20.0199C12.6321 19.9726 12.8786 19.9969 13.1025 20.0896C13.3265 20.1824 13.5179 20.3395 13.6526 20.5411C13.7873 20.7426 13.8592 20.9796 13.8592 21.222C13.8592 21.5471 13.73 21.8589 13.5002 22.0887C13.2703 22.3186 12.9585 22.4477 12.6335 22.4477ZM12.6335 17.8696C12.3923 17.8696 12.1566 17.798 11.9562 17.6638C11.7558 17.5297 11.5997 17.339 11.5078 17.1161C11.4159 16.8931 11.3923 16.6479 11.4399 16.4115C11.4875 16.1751 11.6043 15.9581 11.7754 15.7882C11.9465 15.6182 12.1642 15.5029 12.4009 15.4568C12.6377 15.4108 12.8827 15.4361 13.1051 15.5295C13.3274 15.6229 13.517 15.7802 13.6498 15.9815C13.7826 16.1828 13.8527 16.419 13.8511 16.6601C13.8489 16.9803 13.7208 17.2867 13.4945 17.513C13.2681 17.7394 12.9617 17.8675 12.6416 17.8696H12.6335ZM20.4341 21.5873H15.3933C15.2921 21.5873 15.1951 21.5471 15.1236 21.4756C15.052 21.404 15.0118 21.307 15.0118 21.2058C15.0118 21.1046 15.052 21.0076 15.1236 20.936C15.1951 20.8645 15.2921 20.8243 15.3933 20.8243H20.4423C20.5434 20.8243 20.6405 20.8645 20.712 20.936C20.7836 21.0076 20.8238 21.1046 20.8238 21.2058C20.8238 21.307 20.7836 21.404 20.712 21.4756C20.6405 21.5471 20.5434 21.5873 20.4423 21.5873H20.4341ZM24.7038 17.0417H15.3933C15.2928 17.0396 15.197 16.9987 15.1259 16.9276C15.0548 16.8565 15.0139 16.7607 15.0118 16.6601C15.018 16.5632 15.0609 16.4723 15.1318 16.406C15.2027 16.3396 15.2962 16.3028 15.3933 16.303H24.7119C24.7623 16.3019 24.8124 16.311 24.8592 16.3298C24.906 16.3485 24.9485 16.3766 24.9842 16.4123C25.0198 16.4479 25.0479 16.4904 25.0667 16.5372C25.0854 16.584 25.0946 16.6341 25.0934 16.6845C25.0872 16.7814 25.0443 16.8723 24.9734 16.9387C24.9026 17.005 24.809 17.0418 24.7119 17.0417H24.7038ZM24.7038 12.983H15.3933C15.2921 12.983 15.1951 12.9428 15.1236 12.8713C15.052 12.7997 15.0118 12.7027 15.0118 12.6015C15.0118 12.5003 15.052 12.4033 15.1236 12.3317C15.1951 12.2602 15.2921 12.22 15.3933 12.22H24.7119C24.8131 12.22 24.9102 12.2602 24.9817 12.3317C25.0532 12.4033 25.0934 12.5003 25.0934 12.6015C25.0934 12.7027 25.0532 12.7997 24.9817 12.8713C24.9102 12.9428 24.8131 12.983 24.7119 12.983H24.7038Z'
          fill='#FC9F69'
        />
      </g>
      <defs>
        <filter
          id='filter0_di_1532_2224'
          x='5.57339'
          y='6.01184'
          width='29.1991'
          height='29.2086'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2.17389' />
          <feGaussianBlur stdDeviation='1.63042' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.49 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1532_2224'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1532_2224'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='7.60863' dy='-2.17389' />
          <feGaussianBlur stdDeviation='3.80432' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.895833 0 0 0 0 0.884635 0 0 0 0 0.884635 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_1532_2224'
          />
        </filter>
      </defs>
    </svg>
  );
};

export default TaskIcon;
